export enum GridTypes {
  USER_GRID = 'userGrid',
  SHARED_GRIDS = 'sharedGrid'
}

export const GRID_TYPES: GridTypes[] = [GridTypes.USER_GRID, GridTypes.SHARED_GRIDS];

export const GRID_TYPE_LABELS: Record<GridTypes, string> = {
  [GridTypes.USER_GRID]: 'IOT_DICTIONARY.MY_GRIDS',
  [GridTypes.SHARED_GRIDS]: 'IOT_DICTIONARY.SHARED_GRIDS'
};
